// src/modules/revisionPlataformas/pages/RevisionPlataformasPage.jsx
import React, { useState } from "react";
import { Box, Paper, Button } from "@mui/material";
import AssessmentIcon from "@mui/icons-material/Assessment";
import DashboardLayout from "../../../layouts/DashboardLayout";
import PageHeader from "../../../components/layout/PageHeader";
import ReporteEquiposSinFacturarDialog from "../../panelGlobal/components/ReporteEquiposSinFacturarDialog";

export default function RevisionPlataformasPage() {
  const [reportePlataformaAbierta, setReportePlataformaAbierta] = useState(null);

  return (
    <DashboardLayout>
      <PageHeader
        title="Revisión Plataformas"
        subtitle="Reportes de revisión: equipos registrados en Wialon/Leasecontrol que no se están facturando"
        backTo="/dashboard"
      />

      <Box sx={{ p: { xs: 1, md: 1.5 } }}>
        <Paper variant="outlined" sx={{ p: 1.25, mb: 2 }}>
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, alignItems: "center" }}>
            <Button
              size="small"
              variant="outlined"
              startIcon={<AssessmentIcon />}
              onClick={() => setReportePlataformaAbierta("wialon")}
              sx={{ whiteSpace: "nowrap", py: 0.5, flex: "0 0 auto" }}
            >
              Equipos sin Facturar (Wialon)
            </Button>
            <Button
              size="small"
              variant="outlined"
              startIcon={<AssessmentIcon />}
              onClick={() => setReportePlataformaAbierta("leasecontrol")}
              sx={{ whiteSpace: "nowrap", py: 0.5, flex: "0 0 auto" }}
            >
              Equipos sin Facturar (Leasecontrol)
            </Button>
          </Box>
        </Paper>
      </Box>

      <ReporteEquiposSinFacturarDialog
        open={Boolean(reportePlataformaAbierta)}
        onClose={() => setReportePlataformaAbierta(null)}
        plataforma={reportePlataformaAbierta || "wialon"}
        labelPlataforma={reportePlataformaAbierta === "leasecontrol" ? "Leasecontrol" : "Wialon"}
      />
    </DashboardLayout>
  );
}
